/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PearsonTemplatesSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('PEARSON_TEMPLATES')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class PearsonTemplatesSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PearsonTemplatesSettingParser.decode(input).map(res => new PearsonTemplatesSetting(res));
    }
    static unsafeDecode(input) {
        return PearsonTemplatesSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PearsonTemplatesSettingParser.encode(data);
    }
    static schema() {
        return PearsonTemplatesSettingParser.schema();
    }
}
